module.exports = __webpack_public_path__ + "img/ct_seque.7a9cd1f2.png";